// extracted by mini-css-extract-plugin
export default {"tooltip":"Ym-z","sharingV2":"Zm-z","sharingIconsV2":"_m-z","links":"an-z","link":"bn-z","facebookV2":"cn-z","twitterV2":"dn-z","pinterestV2":"en-z"};